import React, { Component } from 'react';
import VirtualizedTable from "../common/virtualized-table";
import {Radio} from "@blueprintjs/core";
import {List, Map} from "immutable";

class SelectProductDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedProduct: -1,
            productSuppliers: List([])
        }
    }
    componentDidMount() {
        this.props.onRef(this);
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    getProduct = (productId) => {
        const { products } = this.props;
        const index = products.findIndex( product => product.get('_id') === productId );

        return products.get(index);
    };

    onSelectButtonClick = () => {
        this.props.setProductState(this.state.selectedProduct, this.state.productSuppliers);
        this.props.onCloseModal();
    };

    render() {

        // Product Table
        let tableData = this.props.products.delete(0);
        let tableSettings = {
            sortable: false,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false,
            conditionalRowStyle: [{
                dataField: '_id',
                operation: '=',
                value: this.state.selectedProduct,
                style: {
                    backgroundColor: '#E8F1F7'
                }
            }],
            rowStyle: {
                color: '#676a6c'
            }
        };
        let tableColumns = {
            product_code: {
                title: 'Código',
                columnType: 'text',
                dataField: 'product_code',
                width: 100,
                style: {},
                sortable: false,
                filterable: true
            },
            name: {
                title: "Nombre",
                columnType: 'text',
                dataField: 'name',
                width: 100,
                style: {},
                sortable: false,
                filterable: true
            },
            category_labels: {
                title: "Categorias",
                columnType: 'function',
                dataField: 'category_labels',
                width: 100,
                style: {},
                sortable: false,
                filterable: true,
                nodeContent: (category_labels) => {
                    category_labels = category_labels.map( (category, i) => {
                        return i < category_labels.length -1 ? category + ', ' : category;
                    });

                    return category_labels;
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (productId) => {
                    const product = this.getProduct(productId);
                    return (
                        <Radio
                            style={{ marginTop: 10 }}
                            checked={ productId === this.state.selectedProduct }
                            onChange={ () => {

                                let suppliersList = new List(product.get('suppliers'));
                                let suppliers = List([]);

                                suppliers = suppliers.insert(0, Map({
                                    _id: -1,
                                    label: 'Selecciona un proveedor'
                                }));

                                suppliersList.forEach(supplier => {
                                    suppliers = suppliers.insert(suppliers.size, supplier.get('supplier').merge({
                                            label: supplier.getIn(['supplier', 'basic_info', 'name'])
                                        })
                                    );
                                });

                                this.setState({
                                    selectedProduct: productId,
                                    productSuppliers: suppliers
                                }, this.props.onCanSelectProduct(true));
                            }}
                        />
                    );
                }
            }
        };

        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectProductDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/SelectProductDialog.js